import { render, staticRenderFns } from "./TradeAccount.vue?vue&type=template&id=57ab7530&scoped=true&lang=pug"
import script from "./TradeAccount.vue?vue&type=script&lang=js"
export * from "./TradeAccount.vue?vue&type=script&lang=js"
import style0 from "./TradeAccount.vue?vue&type=style&index=0&id=57ab7530&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab7530",
  null
  
)

export default component.exports